import PropTypes from "prop-types";

// Picks the saved `<image_key>_alt` values off a record so a form can edit them.
export const pickAltText = (record, fields) =>
  fields.reduce((acc, field) => {
    acc[field] = record?.[field] || "";
    return acc;
  }, {});

const AltTextInput = ({ className, label, field, values, setValues }) => (
  <div className={className}>
    <div className="fieldrow">
      <label className="f_label">{label}</label>
      <input
        className="f_input"
        type="text"
        maxLength={255}
        placeholder=""
        value={values?.[field] || ""}
        onChange={(e) => {
          const value = e.target.value;
          setValues((prev) => ({ ...prev, [field]: value }));
        }}
      />
    </div>
  </div>
);

AltTextInput.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  field: PropTypes.string,
  values: PropTypes.object,
  setValues: PropTypes.func,
};

export default AltTextInput;
